<template>
  <div class="apply-page">
    <div class="apply-hero">
      <h1>专家库申请</h1>
      <p>填写公开资料并上传照片、简历。提交后进入审核，预计 1–3 个工作日，请保持电话畅通。</p>
    </div>

    <el-form
      class="apply-card"
      v-loading="loading"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="108px"
    >
      <div class="apply-head">
        <el-form-item prop="expertPicture" class="apply-avatar-item" label-width="0">
          <GsUpload
            v-model="ruleForm.expertPicture"
            kind="image"
            :limit="1"
            add-text="上传照片"
            tip="png / jpg，建议正方形"
          />
        </el-form-item>
        <div class="apply-head-fields">
          <el-row :gutter="16">
            <el-col :span="12">
              <el-form-item label="专家姓名" prop="name">
                <el-input v-model="ruleForm.name" placeholder="请输入真实姓名" maxlength="40" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="组织/企业" prop="enterpriseName">
                <el-input v-model="ruleForm.enterpriseName" placeholder="请输入所在组织或企业" maxlength="80" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职位" prop="position">
                <el-input v-model="ruleForm.position" placeholder="请输入职位" maxlength="40" clearable />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="擅长行业" prop="specialtyDomain">
                <GsSelect v-model="ruleForm.specialtyDomain" class="wp100" filterable placeholder="请选择擅长行业" :options="specialtyDomainSelect" />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>

      <TitleTool title="联系与地区" />
      <el-row :gutter="16">
        <el-col :span="12">
          <el-form-item label="联系方式" prop="tel">
            <el-input v-model="ruleForm.tel" placeholder="请输入手机号" maxlength="11" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱" prop="mail">
            <el-input v-model="ruleForm.mail" placeholder="选填" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="地区" prop="area">
            <GsRegionSelect v-model="ruleForm.area" placeholder="请选择省 / 市 / 区，可清除" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="办公地址" prop="officeAddress">
            <GsRegionAddress v-model="ruleForm.officeAddress" />
          </el-form-item>
        </el-col>
      </el-row>

      <TitleTool title="个人介绍" />
      <el-form-item label="个人描述" prop="expertProfile">
        <el-input
          v-model="ruleForm.expertProfile"
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 6 }"
          maxlength="800"
          show-word-limit
          placeholder="介绍专业背景、研究或服务方向"
        />
      </el-form-item>
      <el-form-item label="专家名句" prop="expertSentence">
        <el-input v-model="ruleForm.expertSentence" placeholder="一句可公开的专业观点或寄语" maxlength="80" show-word-limit clearable />
      </el-form-item>

      <TitleTool title="简历附件" />
      <el-form-item label="简历" prop="resumeAttachment" label-width="108px">
        <GsUpload
          v-model="ruleForm.resumeAttachment"
          kind="file"
          :limit="3"
          accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf,.txt"
          add-text="上传简历"
          tip="支持 doc / docx / pdf / ppt / xls / txt，最多 3 个"
        />
      </el-form-item>
    </el-form>

    <div class="apply-actions">
      <el-button @click="closeExpert">取消</el-button>
      <el-button type="primary" @click="saveExpert">提交申请</el-button>
    </div>
  </div>
</template>

<script>
import { getDataType, expertInfoSave } from '@/api/Layout/index.js'
import { enumType } from '@/utils/enum.js'
import GsRegionSelect from '@/components/GsRegionSelect/index.vue'
import GsUpload from '@/components/GsUpload/index.vue'
import GsRegionAddress from '@/components/GsRegionAddress/index.vue'
import { gsConfirm } from '@/utils/gsConfirm'
import './apply-form.css'

export default {
  name: 'AddExpert',
  components: { GsRegionSelect, GsUpload, GsRegionAddress },
  data() {
    return {
      loading: false,
      specialtyDomainSelect: [],
      ruleForm: {
        name: '',
        enterpriseName: '',
        tel: '',
        mail: '',
        position: '',
        expertProfile: '',
        expertSentence: '',
        officeAddress: '',
        specialtyDomain: '',
        publishStatus: '0',
        handleStatus: '0',
        expertPicture: [],
        resumeAttachment: [],
        area: []
      },
      rules: {
        name: [{ required: true, message: '请输入专家姓名', trigger: ['blur', 'change'] }],
        enterpriseName: [{ required: true, message: '请输入组织/企业', trigger: ['blur', 'change'] }],
        tel: [
          { required: true, message: '请输入联系电话', trigger: ['blur', 'change'] },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: ['blur', 'change'] }
        ],
        specialtyDomain: [{ required: true, message: '请选择擅长行业', trigger: ['blur', 'change'] }],
        position: [{ required: true, message: '请输入职位', trigger: ['blur', 'change'] }],
        expertProfile: [{ required: true, message: '请输入专家个人描述', trigger: ['blur', 'change'] }],
        area: [{ required: true, type: 'array', min: 1, message: '请选择地区', trigger: ['blur', 'change'] }],
        expertSentence: [{ required: true, message: '请输入专家名句', trigger: ['blur', 'change'] }],
        officeAddress: [{ required: true, message: '请输入办公地址', trigger: ['blur', 'change'] }]
      }
    }
  },
  created() {
    this.getData('sys_expert_specialty_domain')
  },
  methods: {
    async getData(type) {
      try {
        const res = await getDataType(type)
        this.specialtyDomainSelect = res && res.data && res.data.length ? enumType(res.data) : []
      } catch (error) {
        this.specialtyDomainSelect = []
      }
    },
    joinFiles(list) {
      return Array.isArray(list) ? list.filter(Boolean).join(',') : (list || '')
    },
    saveExpert() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return
        const payload = Object.assign({}, this.ruleForm, {
          expertPicture: this.joinFiles(this.ruleForm.expertPicture),
          resumeAttachment: this.joinFiles(this.ruleForm.resumeAttachment),
          area: Array.isArray(this.ruleForm.area) ? JSON.stringify(this.ruleForm.area) : this.ruleForm.area
        })
        gsConfirm({
          message: '确定提交专家库申请吗？',
          confirmButtonText: '提交',
          cancelButtonText: '再看看'
        }).then(() => {
          this.loading = true
          expertInfoSave(payload).then((res) => {
            this.loading = false
            if (res.code === 200) {
              this.$alert('申请已提交，审核需要 1–3 个工作日，请保持电话畅通。', '提交成功', {
                confirmButtonText: '我知道了'
              })
              this.$router.go(-1)
            }
          }).catch(() => {
            this.loading = false
          })
        }).catch(() => {})
      })
    },
    closeExpert() {
      gsConfirm({
        message: '确定离开本页吗？未提交的内容不会保存。',
        confirmButtonText: '离开',
        cancelButtonText: '继续填写'
      }).then(() => {
        this.$router.go(-1)
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.apply-avatar-item {
  margin-bottom: 0;
}
.apply-avatar-item :deep(.el-form-item__content) {
  margin-left: 0 !important;
  line-height: normal;
}
</style>
